import { ScrollArea } from '@mantine/core';
import ModalComponent from '../../../components/modal';
import { useSelector } from 'react-redux';
import { AppState } from '../../../client-redux/reducers';
import { Language } from '../../../languages/languageHandler';

interface SyncCommandModalProps {
  show: boolean;
  handleClose: () => void;
  command: any | null;
}

const formatObjectLikeCode = (obj: any, indent = 2): string => {
  if (!obj) return '';
  const pad = (level: number) => ' '.repeat(level * indent);
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?([+-]\d{2}:\d{2})?$/;
  const sortedEntries = Object.entries(obj).sort(([aKey], [bKey]) => aKey.localeCompare(bKey));
  return sortedEntries
    .map(([key, value]) => {
      let formattedValue;
      if (typeof value === 'string' && !isoDateRegex.test(value)) {
        formattedValue = `"${value}"`;
      } else {
        formattedValue = value;
      }
      return `${pad(1)}${key}: ${formattedValue}`;
    })
    .join('\n');
};

const SyncCommandModal = ({ show, handleClose, command }: SyncCommandModalProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const formattedText = command ? formatObjectLikeCode(command) : '';

  return (
    <ModalComponent
      show={show}
      handleClick={handleClose}
      title={command ? `${lang.GLOBAL_COMMAND_ID}: ${command.commandId}` : ''}
      classname="sync-command-modal"
      z-index={11000}
      content={
        command && (
          <ScrollArea>
            <pre>{formattedText}</pre>
          </ScrollArea>
        )
      }
    />
  );
};

export default SyncCommandModal;
